module.exports = __webpack_public_path__ + "media/assets/images/cloudy_later_will_sunny-79f626bd9090a8a0042fcfe188466203.png";